import React, { Component } from 'react'
import {Route, Redirect} from 'react-router-dom'
import Full from './../containers/Full/Full'
import { PulseLoader } from 'halogenium'
import * as LicenseActionCreators from '../redux/modules/license'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import getActiveorExpiredLicenses from '../helpers/users/licenses/getActiveorExpiredLicenses'

class AuthRoutes extends Component {

    componentDidMount() {
        this.props.testUser && this.props.testUser.licenses && getActiveorExpiredLicenses(this.props.testUser.licenses, {
          getUserLicenseRequest: this.props.getUserLicenseRequest,
          getUserLicenseFaliure: this.props.getUserLicenseFaliure,
          getUserLicenseSuccess: this.props.getUserLicenseSuccess
        });
      }
    
      componentDidUpdate(prevProps) {
        if (this.props.testUser !== prevProps.testUser) {
          this.props.testUser && this.props.testUser.licenses && getActiveorExpiredLicenses(this.props.testUser.licenses, {
            getUserLicenseRequest: this.props.getUserLicenseRequest,
            getUserLicenseFaliure: this.props.getUserLicenseFaliure,
            getUserLicenseSuccess: this.props.getUserLicenseSuccess
          });
        }
      }
    
    
    

    render(){
        let {checkout , checkoutlocation } = this.props.state
        let {isAuthed, isFetching} = this.props.state
        var color = '#4DAF7C';
        var style = {
            "textAlign": "center",
            "position": "absolute",
            "top": "calc(50% - 40px)" ,
            "left": "calc(50% - 132px)"
        }
        if(this.props.userLicenses.fetchingLicenses || isFetching){
            return(
                    <div style={style} >
                        <PulseLoader color={color} size="50px" margin="20px"/>
                    </div>
            )
        }else{
            return(
                <Route render={ (props)=>{ 
                    return !isAuthed ? (
                        !localStorage.getItem('token') && <Redirect
                            to={{
                                pathname: checkout ? `${checkoutlocation}` :'/login',
                                state: { from: this.props.location }
                            }}
                        />
                    ) : (
                        <Full {...this.props} />
                ) } }  />
            )
        }
    }
}


export default connect(
    (state) => ({
      testUser: state.users.testUser,
      userAssessment: state.assessment.userAssessment,
      userLicenses: state.licenses.userlicenses
    }),
    (dispatch) => bindActionCreators(LicenseActionCreators, dispatch)
  )(AuthRoutes)


// WEBPACK FOOTER //
// ./src/config/AuthRoutes.js